import type { ReleaseThemeId } from 'fym-shared/src/music24/releaseThemes';
import type { CoverBankBackground } from '../../../../redux/api/fymAPI.types';

/** The moods of the bank, the most used first, at most `limit`. Pure. */
export function bankMoods(backgrounds: readonly CoverBankBackground[], limit = 8): string[] {
  const counts = new Map<string, number>();
  for (const background of backgrounds) {
    for (const mood of background.moods) {
      counts.set(mood, (counts.get(mood) ?? 0) + 1);
    }
  }
  return [...counts.entries()]
    .sort((a, b) => (b[1] !== a[1] ? b[1] - a[1] : a[0].localeCompare(b[0])))
    .slice(0, limit)
    .map(([mood]) => mood);
}

/** The bank pictures of a theme and a mood; null means every theme or every mood. Pure. */
export function filterBank(
  backgrounds: readonly CoverBankBackground[],
  themeId: ReleaseThemeId | null,
  mood: string | null
): CoverBankBackground[] {
  return backgrounds.filter(
    (background) =>
      (themeId === null || background.themeIds.includes(themeId)) && (mood === null || background.moods.includes(mood))
  );
}
